module.exports = __webpack_public_path__ + "assets/img/isbankasi@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-logo/isbankasi@2x.png
// module id = 134
// module chunks = 0